import * as React from 'react';
import { JRCInputFieldProps } from '../Common/JRCFormFieldRenderer.types';
import { JRCFormFieldRenderer } from '../Common/JRCFormFieldRenderer';
import { FieldValues } from 'react-hook-form';
import { TinyMCECommonOptions } from 'jamespot-user-api';
import { JRCInputTinyMCERaw, MentionQuery } from '../JRCInputTinyMCERaw/JRCInputTinyMCERaw';
import { TinyMCEExtension } from '../JRCInputTinyMCERaw/extensions/JTinyMCEExtensions';

export type JRCInputTinyMCEProps<T extends FieldValues> = JRCInputFieldProps<T> & {
    token?: string;
    commonOptions: TinyMCECommonOptions;
    mentionsQueries: {
        users: MentionQuery;
        tags: MentionQuery;
        contents: MentionQuery;
    };
    additionalExtensions?: Array<TinyMCEExtension>;
};

export const JRCInputTinyMCE = <T extends FieldValues = FieldValues>({
    dataCy,
    token,
    mentionsQueries,
    commonOptions,
    additionalExtensions,
    ...props
}: JRCInputTinyMCEProps<T>) => {
    return (
        <>
            <JRCFormFieldRenderer
                {...props}
                renderFunction={({ onChange, value, onBlur, ref }) => (
                    <JRCInputTinyMCERaw
                        token={token}
                        dataCy={dataCy}
                        commonOptions={commonOptions}
                        value={value}
                        onChange={onChange}
                        mentionsQueries={mentionsQueries}
                        ref={ref}
                        onBlur={onBlur}
                        additionalExtensions={additionalExtensions}
                        readOnly={props.readOnly}
                    />
                )}
            />
        </>
    );
};
